import { useState } from 'react';
import certification from '../assets/icons/certification.png';
import { btnOneLight, btnRound, btnSmall, containerOne, containerTwo, subTitle, title } from '../utils/style';
import clockIcon from '../assets/icons/clock_icon.png'
import playButton2 from '../assets/icons/play_btn_2.png'
import nextIcon from '../assets/icons/next_icon.png'
import backIcon from '../assets/icons/arrow_black.png'
import playButton from '../assets/icons/play_button.png'

function CourseDescription() {
    const [ courseData, setCourseData ] = useState(
        { 
            title: 'Training 1',
            lessons: '33',
            duration: '8h 30min',
            courses: [
                {
                    title: 'Course 1',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 2',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 3',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 4',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 5',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 6',
                    duration: '5min 4 sec'
                },
                {
                    title: 'Course 7',
                    duration: '5min 4 sec'
                },
            ]
        }
    )

    return(
        <div className={containerOne}>
            <div className='flex justify-center bg-customTwo p-4 rounded-xl '>
                <div className='rounded-lg'>
                    <img src={certification} />
                </div>
            </div>
            <div className='flex justify-between items-center py-4 border-b border-customThree'>
                <div className='flex gap-4 items-center'>
                    <div className={title}>{courseData.title}</div>
                    <div className='text-md text-gray-500'>{`(${courseData.lessons} Lessons)`}</div>
                </div>
                <div className={btnOneLight}>
                    <img src={clockIcon}/>
                    <div className='ml-2 text-sm font-semibold'>{courseData.duration}</div>
                </div>
            </div>
            <div className='mb-24'>
                {
                    courseData.courses.map((crs, ind) => 
                        <div key={ind} className='flex py-4 justify-between items-center'>
                            <div className='flex gap-6 items-center'>
                                <div className='bg-customOne rounded-full cursor-pointer'>
                                    <img src={playButton2} />
                                </div>
                                <div>
                                    <div className={subTitle}>{crs.title}</div>
                                    <div className='text-md text-gray-500'>{crs.duration}</div>
                                </div>
                            </div>
                            <div>
                                <img src={nextIcon} className='cursor-pointer'/>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className='flex justify-between fixed bottom-0 right-4 left-4 py-8 z-10 bg-white bg-opacity-50'>
                <div>
                    <img src={backIcon} className={btnRound} />
                </div>
                <div>
                    <button className={btnSmall}>
                        <span>Resume</span>
                        <span className='bg-white rounded-full ml-2'>
                            <img src={playButton} height={25} width={25} />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CourseDescription;